require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-the-local-project-featuring-the-grange-residence.json") })
        }
      }, "path---journal-the-local-project-featuring-the-grange-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-the-local-project-featuring-the-grange-residence!./.cache/json/journal-the-local-project-featuring-the-grange-residence.json
// module id = 541
// module chunks = 231608221292675